import {
	applySiteBackupFilter,
	focusSiteBackup,
	openSiteBackupSection,
} from './adapter';
import {
	openSiteBackupCreateModal,
	openSiteBackupDeleteModal,
	openSiteBackupRestoreModal,
	openSiteBackupUploadModal,
} from './modal';
import {mapSiteBackupPrefill} from './prefill';
import {resolveSiteBackups} from './resolver';
import {serializeSiteBackupContext} from './context';

/**
 * Site Backup.
 *
 * One of two lists on the Backup tab - the other is System Backup, a
 * different resource with its own API, columns, and permission. `edit` is
 * declared so the capability exists to answer "can I edit a backup" with a
 * canned no, but carries no modal: the workflow template for it is
 * `edit_unavailable` and never opens anything.
 */
const siteBackupPlugin = {
	id: 'site_backup',
	version: 1,
	commandVersion: 1,
	resource: 'site_backup',
	operations: [
		'options',
		'view',
		'search',
		'create',
		'upload',
		'download',
		'restore',
		'delete',
		'bulk_delete',
		'refresh',
		'edit',
	],
	dependencies: {
		plugins: ['canvas.navigation', 'backup'],
		destinations: ['maintenance.dashboard'],
	},
	sections: {
		'maintenance.site_backup': openSiteBackupSection,
	},
	resolvers: {
		site_backup: resolveSiteBackups,
	},
	filters: {
		site_backup: applySiteBackupFilter,
	},
	focusHandlers: {
		site_backup: focusSiteBackup,
	},
	modals: {
		'site_backup.create': openSiteBackupCreateModal,
		'site_backup.upload': openSiteBackupUploadModal,
		'site_backup.restore': openSiteBackupRestoreModal,
		'site_backup.delete': openSiteBackupDeleteModal,
	},
	prefillMappers: {
		'site_backup.create': mapSiteBackupPrefill,
	},
	contextSerializers: {
		site_backup: serializeSiteBackupContext,
	},
};

export default siteBackupPlugin;
